import React from 'react';
import './Partnerships.css';

const Partnerships = () => {
  const brands = [
    { name: 'Chevrolet', logo: '🏷️' },
    { name: 'Volkswagen', logo: '🏷️' },
    { name: 'Honda', logo: '🏷️' },
    { name: 'Hyundai', logo: '🏷️' },
    { name: 'Ford', logo: '🏷️' },
    { name: 'Renault', logo: '🏷️' },
    { name: 'Fiat', logo: '🏷️' },
    { name: 'Jeep', logo: '🏷️' },
    { name: 'Toyota', logo: '🏷️' },
    { name: 'Iveco', logo: '🏷️' },
    { name: 'Mercedes-Benz', logo: '🏷️' },
    { name: 'Scania', logo: '🏷️' }
  ];

  return (
    <section className="partnerships">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">
            A bateria escolhida pelas maiores montadoras do mundo
          </h2>
        </div>
        
        <div className="brands-grid">
          {brands.map((brand, index) => (
            <div key={index} className="brand-card">
              <div className="brand-logo">
                <span className="brand-emoji">{brand.logo}</span>
              </div>
              <span className="brand-name">{brand.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partnerships;
